import { GLOWApiClient, TAGS } from '../apiClients/GLOWClient';

type Id = number | string;

export const unavailabilityApi = GLOWApiClient.injectEndpoints({
  endpoints: (build) => ({
    employeeUnavailabilities: build.query<any[], { salon: Id; status?: string }>({
      query: ({ salon, status = 'active' }) => ({
        url: '/api/schedules/unavailabilities/',
        params: { salon, status },
      }),
      providesTags: [TAGS.ALL],
    }),
    createEmployeeUnavailability: build.mutation<any, Record<string, unknown>>({
      query: (body) => ({
        url: '/api/schedules/unavailabilities/',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TAGS.ALL],
    }),
    updateEmployeeUnavailability: build.mutation<
      any,
      { id: Id; [key: string]: unknown }
    >({
      query: ({ id, ...body }) => ({
        url: `/api/schedules/unavailabilities/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [TAGS.ALL],
    }),
    deleteEmployeeUnavailability: build.mutation<void, Id>({
      query: (id) => ({
        url: `/api/schedules/unavailabilities/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAGS.ALL],
    }),
    unavailabilityImpacts: build.query<any[], Id>({
      query: (id) => `/api/schedules/unavailabilities/${id}/impacts/`,
      providesTags: [TAGS.ALL],
    }),
    resolveUnavailabilityImpacts: build.mutation<
      any[],
      { id: Id; notify_client: boolean; operations: unknown[] }
    >({
      query: ({ id, ...body }) => ({
        url: `/api/schedules/unavailabilities/${id}/resolve/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [TAGS.ALL],
    }),
  }),
});

export const {
  useEmployeeUnavailabilitiesQuery,
  useCreateEmployeeUnavailabilityMutation,
  useUpdateEmployeeUnavailabilityMutation,
  useDeleteEmployeeUnavailabilityMutation,
  useUnavailabilityImpactsQuery,
  useResolveUnavailabilityImpactsMutation,
} = unavailabilityApi;
